import React, { Suspense, lazy, useEffect, useState } from "react";
import { RightOutlined, SearchOutlined } from "@ant-design/icons";
import { Popover } from "@mui/material";
import { ErrorMessage, Form, Formik } from "formik";
import * as Yup from "yup";
import TextError from "../../TextError";
import { useDispatch, useSelector } from "react-redux";
// import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {
  getallairports,
  searchrates,
  searchratestate,
} from "../../../store/SearchRates/SearchRatesSlice";
import dayjs from "dayjs";
import { useLocation, useNavigate } from "react-router-dom";
import { IncoTerms } from "../../../utils/incoTermsDatas";
import { Modal, Skeleton } from "antd";
import moment from "moment/moment";
import { useSearchParams } from "react-router-dom";
import {
  authtokenloginAirline,
  loginAirline,
} from "../../../store/LoginAirlineAuth/AuthSlice";
import { set } from "react-hook-form";
import {
  vehicletype,
  caldistance,
} from "../../../store/vehicletype/Vehicletypeslice";
import axios from "axios";
import { updatenotificationdata } from "../../../store/Admin/Common/CommonSlice";
import FailureSearchRate from "../../../components/SearchRates/FailureSearchRate";
import { getsinglebookingdata } from "../../../store/BookingHistory/BookingHistorySlice";
import { checkStackableandTurnable } from "../../../utils/dropdownValues";
const OriginAirport = lazy(() => import("./OriginAirport/OriginAirport"));
const DestinationAirport = lazy(() =>
  import("./DestinationAirport/DestinationAirport")
);
const GoodDetails = lazy(() => import("./GoodsDetails/GoodDetails"));
const PackagingDetails = lazy(() =>
  import("./PackagingDetails/PackagingDetails")
);
const PaymentTerms = lazy(() => import("./PaymentTerms/PaymentTerms"));

const FlightRate = ({ searchBy, searchFormData, type }) => {
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [formikData, setFormikData] = useState(null);
  const [popForm, setPopForm] = useState();
  const [airports, setAirports] = useState([]);
  const [webopen, setWebOpen] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [error, setError] = useState(null);
  const [popup, setPopup] = useState("");
  const [origin, setOrigin] = useState("");
  const [originvehicle, setOriginVehicle] = useState([]);
  const [destinationvehicle, setDestinationVehicle] = useState([]);
  const [destination, setDestination] = useState("");
  const [searchquery, setSearchQuery] = useState({});
  // console.log("vehicletype", originvehicle[0]?._id, destinationvehicle);
  const [selectedVehicle, setSelectedVehicle] = useState({
    destinationVehicle: "",
    originVehicle: "",
  });
  const [originDistance, setOriginDistance] = useState();
  const [editdata, setEditData] = useState({});
  const [editbookeditem, setEditbookeditem] = useState({});
  const [editpayload, setEditPayload] = useState({});
  const [destinationDistance, setDestinationDistance] = useState();
   const [comodityMaster, setcomodityMaster] = useState([]);
  const [vasoptiondata, setVasOptionData] = useState([]);
  console.log(editdata, "editdata");
  console.log(editbookeditem, "editbookeditem");
  console.log(editpayload, "editpayload");
  // console.log(originvehicle, "originvehicle",destinationvehicle,"destinationvehicle");
  // console.log(destinationvehicle, "destinationvehicle", originvehicle,"originvehicle");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const queryId = searchParams.get("queryId");
  const editQueryData = location.state;
  // console.log("queryId", queryId);
  const allAirportsState = useSelector(searchratestate);

  // console.log(selectedVehicle, "selectedVehiclefdg");
  console.log("countrynamehiiooo", type, searchBy, searchFormData);
  const handleClick = (event, formik, popform) => {
    if (type === "kam_admin") return;
    // console.log(formik, "formik");
    setAnchorEl(event.currentTarget);
    setFormikData(formik);
    setPopForm(popform);
    // console.log(searchFormData, "yhbrt");
  };
  useEffect(() => {
    const payload = {
      queryId: queryId,
    };
    dispatch(getsinglebookingdata(payload))
      .then((res) => {
        // console.log(
        //   res?.payload?.data?.data,
        //   "Query ID saved successfully."
        // );
        setEditbookeditem(res?.payload?.data?.data);
        setEditPayload(
          res?.payload?.data?.data?.search_query_data ||
            editQueryData?.search_query_data
        );
        setEditData(
          res?.payload?.data?.data?.search_query_data ||
            editQueryData?.search_query_data
        );
      })
      .catch((error) => {
        console.error("Error saving query ID:", error);
      });
  }, [queryId]);
  const login = async () => {
    try {
      const payload = {
        username: "sgate.jasprits@gmail.com",
        password: "Sgate#9430",
      };
      console.log(payload);
      const response = await axios.post(
        `https://cdutils.sgate.net/api/v1/auth/login`,
        payload
      );

      // Auth-hardening pass: this token used to be persisted to localStorage
      // under "tokenairline", but nothing in this component (or, per a
      // repo-wide search, any other file) ever reads it back — it's used
      // directly below, in this same closure. Removed rather than replaced
      // with in-memory storage since it was dead weight even before the
      // hardening: no auth-bearing token needs to sit in script-readable
      // browser storage that nothing consumes.
      const token = response?.data?.token;
      if (token) {
        console.log("Token stored!");
        const response = await axios.get(
          `https://cdutils.sgate.net/api/v1/new/commoditylist`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        console.log("Commodity Data:", response.data);
        const comodityMasterOptions = response?.data.data?.map((item) => ({
          value: item?.id,
          // value: item?.commodityCode,
          label: item?.commodity_description,
          QR_code: item?.QR_code,
          // productCode: item?.QR_productCode,
          // specialHandlingCodes: item?.QR_commodityShc,
          // commodityCode: item?.QR_commodityShc,
          commodity_description: item?.commodity_description,
        }));
        setcomodityMaster(comodityMasterOptions);
      }
    } catch (err) {
      console.error("Login error:", err);
    }
  };
   useEffect(() => {
      login();
    }, []);

  console.log("editdata", editdata);
  const handlemodalclose = () => {
    setIsOpen(false);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setPopForm(null);
    // console.log(popForm);
  };
  let specialcargo = {};

  // if (
  //   searchFormData?.searchquery?.goodsDetails.commonditytype
  //     .commonditytypesub === "Dangerous Goods"
  // ) {
  //   specialcargo = {
  //     dangerousgoods: {
  //       DGcommodityname: searchFormData?.searchquery?.goodsDetails
  //         .commonditytype?.specialcargo?.dangerousgoods?.DGcommodityname
  //         ? searchFormData?.searchquery?.goodsDetails.commonditytype
  //             ?.specialcargo?.dangerousgoods?.DGcommodityname
  //         : editdata?.goodsDetails.commonditytype?.specialcargo?.dangerousgoods
  //             ?.DGcommodityname
  //         ? editdata?.goodsDetails.commonditytype?.specialcargo?.dangerousgoods
  //             ?.DGcommodityname
  //         : "",
  //       DGhscode: searchFormData?.searchquery?.goodsDetails.commonditytype
  //         ?.specialcargo?.dangerousgoods?.DGhscode
  //         ? searchFormData?.searchquery?.goodsDetails.commonditytype
  //             ?.specialcargo?.dangerousgoods?.DGhscode
  //         : editdata?.goodsDetails.commonditytype?.specialcargo?.dangerousgoods
  //             ?.DGhscode
  //         ? editdata?.goodsDetails.commonditytype?.specialcargo?.dangerousgoods
  //             ?.DGhscode
  //         : "",
  //       DGclassdescription: searchFormData?.searchquery?.goodsDetails
  //         .commonditytype?.specialcargo?.dangerousgoods?.DGclassdescription
  //         ? searchFormData?.searchquery?.goodsDetails.commonditytype
  //             ?.specialcargo?.dangerousgoods?.DGclassdescription
  //         : editdata?.goodsDetails.commonditytype?.specialcargo?.dangerousgoods
  //             ?.DGclassdescription
  //         ? editdata?.goodsDetails.commonditytype?.specialcargo?.dangerousgoods
  //             ?.DGclassdescription
  //         : "",
  //       DGpackinggroup: searchFormData?.searchquery?.goodsDetails.commonditytype
  //         ?.specialcargo?.dangerousgoods?.DGpackinggroup
  //         ? searchFormData?.searchquery?.goodsDetails.commonditytype
  //             ?.specialcargo?.dangerousgoods?.DGpackinggroup
  //         : editdata?.goodsDetails.commonditytype?.specialcargo?.dangerousgoods
  //             ?.DGpackinggroup
  //         ? editdata?.goodsDetails.commonditytype?.specialcargo?.dangerousgoods
  //             ?.DGpackinggroup
  //         : "",
  //       DGspecialinstructions: searchFormData?.searchquery?.goodsDetails
  //         .commonditytype?.specialcargo?.dangerousgoods?.DGspecialinstructions
  //         ? searchFormData?.searchquery?.goodsDetails.commonditytype
  //             ?.specialcargo?.dangerousgoods?.DGspecialinstructions
  //         : editdata?.goodsDetails.commonditytype?.specialcargo?.dangerousgoods
  //             ?.DGspecialinstructions
  //         ? editdata?.goodsDetails.commonditytype?.specialcargo?.dangerousgoods
  //             ?.DGspecialinstructions
  //         : "",
  //       DGmsdsfile: editdata?.DGmsdsfile ? editdata?.DGmsdsfile : "",
  //       DGpackinglistfile: editdata?.DGpackinglistfile
  //         ? editdata?.DGpackinglistfile
  //         : "",
  //     },
  //   };
  // } else if (
  //   searchFormData?.searchquery?.goodsDetails.commonditytype
  //     .commonditytypesub === "Temperature Controlled / Pharma"
  // ) {
  //   specialcargo = {
  //     temperaturecontrolled: {
  //       TCtempereaturecontroledtype: searchFormData?.searchquery?.goodsDetails
  //         .commonditytype?.specialcargo?.temperaturecontrolled
  //         ?.TCtempereaturecontroledtype
  //         ? searchFormData?.searchquery?.goodsDetails.commonditytype
  //             ?.specialcargo?.temperaturecontrolled?.TCtempereaturecontroledtype
  //         : "",
  //       TCtemperaturecontrolrange: searchFormData?.searchquery?.goodsDetails
  //         .commonditytype?.specialcargo?.temperaturecontrolled
  //         ?.TCtemperaturecontrolrange
  //         ? searchFormData?.searchquery?.goodsDetails.commonditytype
  //             ?.specialcargo?.temperaturecontrolled?.TCtemperaturecontrolrange
  //         : "",
  //       TCspecialinstrictions: searchFormData?.searchquery?.goodsDetails
  //         .commonditytype?.specialcargo?.temperaturecontrolled
  //         ?.TCspecialinstrictions
  //         ? searchFormData?.searchquery?.goodsDetails.commonditytype
  //             ?.specialcargo?.temperaturecontrolled?.TCspecialinstrictions
  //         : "",
  //       TCpackinglistfile: "",
  //     },
  //   };
  // } else if (
  //   searchFormData?.searchquery?.goodsDetails.commonditytype
  //     .commonditytypesub === "Other Special Commodity"
  // ) {
  //   specialcargo = {
  //     specialcommodity: {
  //       OSotherspecialcommoditytype: searchFormData?.searchquery?.goodsDetails
  //         .commonditytype?.specialcargo?.specialcommodity
  //         ?.OSotherspecialcommoditytype
  //         ? searchFormData?.searchquery?.goodsDetails.commonditytype
  //             ?.specialcargo?.specialcommodity?.OSotherspecialcommoditytype
  //         : "",
  //     },
  //   };
  // }
  let PackagesInit = [];
  if (
    searchFormData?.searchquery?.packagingDetails?.packagingType?.packages
      ?.length > 0
  ) {
    searchFormData?.searchquery?.packagingDetails?.packagingType?.packages?.map(
      (item) => {
        // console.log("1366666666666666666", item);
        let obj = {
          units: item.units,
          length: item.length,
          width: item.width,
          height: item.height,
          unit: item.unit,
          weight: item.weight,
          weightunit: item.weightunit,
          packagetype: item.packagetype,
          handling: item.handling,
          totalsubunits: item.totalsubunits,
          totalsubweight: item.totalsubweight,
          totalsubvolume: item.totalsubvolume,
        };
        PackagesInit.push(obj);
        // console.log(obj);
      }
    );
  } else if (editdata?.packagingDetails?.packagingType?.packages?.length > 0) {
    editdata?.packagingDetails?.packagingType?.packages?.map((item) => {
      // console.log("1366666666666666666", item);
      let obj = {
        units: item.units,
        length: item.length,
        width: item.width,
        height: item.height,
        unit: item.unit,
        weight: item.weight,
        weightunit: item.weightunit,
        packagetype: item.packagetype,
        handling: item.handling,
        totalsubunits: item.totalsubunits,
        totalsubweight: item.totalsubweight,
        totalsubvolume: item.totalsubvolume,
      };
      PackagesInit.push(obj);
      // console.log(obj);
    });
  } else {
    PackagesInit.push({
      units: "",
      length: "",
      width: "",
      height: "",
      unit: "CM",
      weight: "",
      weightunit: "KG/UNIT",
      packagetype: "Box",
      handling: "Tiltable and Stackable",
      totalsubunits: "",
      totalsubweight: "",
      totalsubvolume: "",
      Temp: "",
    });
  }
  // console.log("searchFormData", searchFormData?.queryId);
  //   console.log("editdatainitialvalue",editdata)
  const initialValues = {
    cargoType: searchBy,
    originAirport: {
      originAirport: searchFormData?.searchquery?.originAirport.originAirport
        ? searchFormData?.searchquery?.originAirport.originAirport
        : editdata?.originAirport?.originAirport
        ? editdata?.originAirport?.originAirport
        : "",
      originLocation: searchFormData?.searchquery?.originAirport.originLocation
        ? searchFormData?.searchquery?.originAirport.originLocation
        : editdata?.originAirport?.originLocation
        ? editdata?.originAirport?.originLocation
        : "",
      originPickup: searchFormData?.searchquery?.originAirport.originPickup
        ? true
        : false || editdata?.originAirport?.originPickup
        ? editdata?.originAirport?.originPickup
        : false,
      // originVehicleType: selectedVehicle.originVehicle,
      // originVehicleType:selectedVehicle?.originVehicle,
      //   pickupToOriginAirportDistance:originDistance?parseFloat(originDistance):0,
      originLocationMarker: searchFormData?.searchquery?.originAirport
        .originLocationMarker
        ? searchFormData?.searchquery?.originAirport.originLocationMarker
        : editdata?.originAirport?.originLocationMarker
        ? editdata?.originAirport?.originLocationMarker
        : {},
      originPortMarker: searchFormData?.searchquery?.originAirport
        .originPortMarker
        ? searchFormData?.searchquery?.originAirport.originPortMarker
        : editdata?.originAirport?.originPortMarker
        ? editdata?.originAirport?.originPortMarker
        : {},
      originLocationCountry: searchFormData?.searchquery?.originAirport
        .originLocationCountry
        ? searchFormData?.searchquery?.originAirport.originLocationCountry
        : editdata?.originAirport?.originLocationCountry
        ? editdata?.originAirport?.originLocationCountry
        : "",
      origincityName: searchFormData?.searchquery?.originAirport?.origincityName
        ? searchFormData?.searchquery?.originAirport?.origincityName
        : editdata?.originAirport?.origincityName
        ? editdata?.originAirport?.origincityName
        : "",
      origincountryName: searchFormData?.origincountryName
        ? searchFormData?.origincountryName
        : editdata?.originAirport?.origincountryName
        ? editdata?.originAirport?.origincountryName
        : "",
      originLogoUrl: searchFormData?.searchquery?.originAirport?.originLogoUrl
        ? searchFormData?.searchquery?.originAirport?.originLogoUrl
        : editdata?.originAirport?.originLogoUrl
        ? editdata?.originAirport?.originLogoUrl
        : "",
    },
    destinationAirport: {
      destinationAirport: searchFormData?.searchquery?.destinationAirport
        .destinationAirport
        ? searchFormData?.searchquery?.destinationAirport.destinationAirport
        : editdata?.destinationAirport?.destinationAirport
        ? editdata?.destinationAirport?.destinationAirport
        : "",
      destinationLocation: searchFormData?.searchquery?.destinationAirport
        .destinationLocation
        ? searchFormData?.searchquery?.destinationAirport.destinationLocation
        : editdata?.destinationAirport?.destinationLocation
        ? editdata?.destinationAirport?.destinationLocation
        : "",
      destinationPickup: searchFormData?.searchquery?.destinationAirport
        .destinationPickup
        ? true
        : false || editdata?.destinationAirport?.destinationPickup
        ? editdata?.destinationAirport?.destinationPickup
        : false,
      // destionationVehicleType: selectedVehicle.destinationVehicle,
      // destionationVehicleType:selectedVehicle?.destinationVehicle,
      // pickupToDestionationAirportDistance:destinationDistance?parseFloat(destinationDistance):0,
      destinationLocationMarker: searchFormData?.searchquery?.destinationAirport
        .destinationLocationMarker
        ? searchFormData?.searchquery?.destinationAirport
            .destinationLocationMarker
        : editdata?.destinationAirport?.destinationLocationMarker
        ? editdata?.destinationAirport?.destinationLocationMarker
        : {},
      destinationPortMarker: searchFormData?.searchquery?.destinationAirport
        .destinationPortMarker
        ? searchFormData?.searchquery?.destinationAirport.destinationPortMarker
        : editdata?.destinationAirport?.destinationPortMarker
        ? editdata?.destinationAirport?.destinationPortMarker
        : {},
      destinationLocationCountry: searchFormData?.searchquery
        ?.destinationAirport.destinationLocationCountry
        ? searchFormData?.searchquery?.destinationAirport
            .destinationLocationCountry
        : editdata?.destinationAirport?.destinationLocationCountry
        ? editdata?.destinationAirport?.destinationLocationCountry
        : "",
      destinationcityName: searchFormData?.searchquery?.destinationAirport
        .destinationcityName
        ? searchFormData?.searchquery?.destinationAirport.destinationcityName
        : editdata?.destinationAirport?.destinationcityName
        ? editdata?.destinationAirport?.destinationcityName
        : "",
      destinationcountryName: searchFormData?.searchquery?.destinationAirport
        .destinationcountryName
        ? searchFormData?.searchquery?.destinationAirport.destinationcountryName
        : editdata?.destinationAirport?.destinationcountryName
        ? editdata?.destinationAirport?.destinationcountryName
        : "",
      destinationLogoUrl: searchFormData?.searchquery?.destinationAirport?.destinationLogoUrl
        ? searchFormData?.searchquery?.destinationAirport?.destinationLogoUrl
        : editdata?.destinationAirport?.destinationLogoUrl
        ? editdata?.destinationAirport?.destinationLogoUrl
        : "",
    },
    goodsDetails: {
      cargoreadydate: searchFormData?.searchquery?.goodsDetails.cargoreadydate
        ? searchFormData?.searchquery?.goodsDetails.cargoreadydate
        : editdata?.goodsDetails?.cargoreadydate
        ? editdata?.goodsDetails?.cargoreadydate
        : dayjs().add(1, "day").format("DD/MM/YYYY"),
      // commonditytype: {
      //   commonditytype: searchFormData?.searchquery?.goodsDetails.commonditytype
      //     .commonditytype
      //     ? searchFormData?.searchquery?.goodsDetails.commonditytype
      //         .commonditytype
      //     : editdata?.goodsDetails?.commonditytype?.commonditytype ||
      //       "General Cargo",
      //   commonditytypesub: searchFormData?.searchquery?.goodsDetails
      //     .commonditytype.commonditytypesub
      //     ? searchFormData?.searchquery?.goodsDetails.commonditytype
      //         .commonditytypesub
      //     : editdata?.goodsDetails?.commonditytype?.commonditytypesub || "All",

      //   generalcargo: {
      //     generalgoods: editdata?.goodsDetails?.commonditytype?.generalcargo
      //       ?.generalgoods
      //       ? editdata?.goodsDetails?.commonditytype?.generalcargo?.generalgoods
      //       : "All",
      //   },
      //   specialcargo,
      // },
    },
    packagingDetails: {
      packagingDetailsBy: searchFormData?.searchquery?.packagingDetails
        .packagingDetailsBy
        ? searchFormData?.searchquery?.packagingDetails.packagingDetailsBy
        : editdata?.packagingDetails?.packagingDetailsBy
        ? editdata?.packagingDetails?.packagingDetailsBy
        : "Packaging Type",
      shipmentTotal: {
        totalunits: searchFormData?.searchquery?.packagingDetails?.shipmentTotal
          ?.totalunits
          ? searchFormData?.searchquery?.packagingDetails.shipmentTotal
              .totalunits
          : editdata?.packagingDetails?.shipmentTotal?.totalunits
          ? editdata?.packagingDetails?.shipmentTotal?.totalunits
          : "",
        totalvolume: searchFormData?.searchquery?.packagingDetails
          ?.shipmentTotal?.totalvolume
          ? searchFormData?.searchquery?.packagingDetails.shipmentTotal
              .totalvolume
          : editdata?.packagingDetails?.shipmentTotal?.totalvolume
          ? editdata?.packagingDetails?.shipmentTotal?.totalvolume
          : "",
        unit: searchFormData?.searchquery?.packagingDetails?.shipmentTotal?.unit
          ? searchFormData?.searchquery?.packagingDetails.shipmentTotal.unit
          : editdata?.packagingDetails?.shipmentTotal?.unit
          ? editdata?.packagingDetails?.shipmentTotal?.unit
          : "CBM",
        totalweight: searchFormData?.searchquery?.packagingDetails
          ?.shipmentTotal?.totalweight
          ? searchFormData?.searchquery?.packagingDetails.shipmentTotal
              .totalweight
          : editdata?.packagingDetails?.shipmentTotal?.totalweight
          ? editdata?.packagingDetails?.shipmentTotal?.totalweight
          : "",
        weightunit: searchFormData?.searchquery?.packagingDetails?.shipmentTotal
          ?.weightunit
          ? searchFormData?.searchquery?.packagingDetails.shipmentTotal
              .weightunit
          : editdata?.packagingDetails?.shipmentTotal?.weightunit
          ? editdata?.packagingDetails?.shipmentTotal?.weightunit
          : "KG",
        totalpackagetype: searchFormData?.searchquery?.packagingDetails
          ?.shipmentTotal?.totalpackagetype
          ? searchFormData?.searchquery?.packagingDetails.shipmentTotal
              .totalpackagetype
          : editdata?.packagingDetails?.shipmentTotal?.totalpackagetype
          ? editdata?.packagingDetails?.shipmentTotal?.totalpackagetype
          : "Box",
        handling: searchFormData?.searchquery?.packagingDetails?.shipmentTotal
          ?.handling
          ? searchFormData?.searchquery?.packagingDetails.shipmentTotal.handling
          : editdata?.packagingDetails?.shipmentTotal?.handling
          ? editdata?.packagingDetails?.shipmentTotal?.handling
          : "Tiltable and Stackable",
        packinglistfile: editdata?.packagingDetails?.shipmentTotal
          ?.packinglistfile
          ? editdata?.packagingDetails?.shipmentTotal?.packinglistfile
          : "",
        weightless: searchFormData?.searchquery?.packagingDetails?.shipmentTotal
          ?.weightless
          ? searchFormData?.searchquery?.packagingDetails.shipmentTotal
              .weightless
          : editdata?.packagingDetails?.shipmentTotal?.weightless
          ? editdata?.packagingDetails?.shipmentTotal?.weightless
          : "",
        dimensionless: searchFormData?.searchquery?.packagingDetails
          ?.shipmentTotal?.dimensionless
          ? searchFormData?.searchquery?.packagingDetails.shipmentTotal
              .dimensionless
          : editdata?.packagingDetails?.shipmentTotal?.dimensionless
          ? editdata?.packagingDetails?.shipmentTotal?.dimensionless
          : "",
      },
      packagingType: {
        packages: editdata?.packagingDetails?.packagingType?.PackagesInit
          ? editdata?.packagingDetails?.packagingType?.PackagesInit
          : PackagesInit,
        totalunits: searchFormData?.searchquery?.packagingDetails?.packagingType
          ?.totalunits
          ? searchFormData?.searchquery?.packagingDetails.packagingType
              .totalunits
          : editdata?.packagingDetails?.packagingType?.totalunits
          ? editdata?.packagingDetails?.packagingType?.totalunits
          : "",
        totalvolume: searchFormData?.searchquery?.packagingDetails
          ?.packagingType?.totalvolume
          ? searchFormData?.searchquery?.packagingDetails.packagingType
              .totalvolume
          : editdata?.packagingDetails?.packagingType?.totalvolume
          ? editdata?.packagingDetails?.packagingType?.totalvolume
          : "",
        totalweight: searchFormData?.searchquery?.packagingDetails
          ?.packagingType?.totalweight
          ? searchFormData?.searchquery?.packagingDetails.packagingType
              .totalweight // here to change the code to set value in the packagetype outer value in the form
          : editdata?.packagingDetails?.packagingType?.totalweight
          ? editdata?.packagingDetails?.packagingType?.totalweight
          : "",
        weightMode: searchFormData?.searchquery?.packagingDetails?.packagingType?.weightMode
          ? searchFormData?.searchquery?.packagingDetails.packagingType.weightMode
          : editdata?.packagingDetails?.packagingType?.weightMode
          ? editdata?.packagingDetails?.packagingType?.weightMode
          : 1,
      },
    },
    paymentTerms: {
      paymentType: searchFormData?.searchquery?.paymentTerms.paymentType
        ? searchFormData?.searchquery?.paymentTerms.paymentType
        : editdata?.paymentTerms?.paymentType
        ? editdata?.paymentTerms?.paymentType
        : "Prepaid",
      incoTerms: searchFormData?.searchquery?.paymentTerms.incoTerms
        ? searchFormData?.searchquery?.paymentTerms.incoTerms
        : editdata?.paymentTerms?.incoTerms
        ? editdata?.paymentTerms?.incoTerms
        : "",
      optionalVas: searchFormData?.searchquery?.paymentTerms?.optionalVas
        ? searchFormData?.searchquery?.paymentTerms?.optionalVas
        : editdata?.paymentTerms?.optionalVas
        ? editdata?.paymentTerms?.optionalVas
        : [],
    },
  };
  // console.log("initialValues", initialValues);
  const validationSchema = Yup.object().shape({
    originAirport: Yup.object().shape({
      originAirport: Yup.string().required("Origin Airport is required"),
    }),
    destinationAirport: Yup.object().shape({
      destinationAirport: Yup.string().required(
        "Destination Airport is required"
      ),
    }),
    // goodsDetails: Yup.object().shape({
    //   commonditytype: Yup.object().shape({
    //     commonditytype: Yup.string().required("Goods Details is required"),
    //   }),
    // }),
    // packagingDetails: Yup.object().shape({
    //   packagingDetailsBy: Yup.string().required("Packing Details is required"),
    // }),
    // packagingDetails: Yup.object().shape({
    //   packagingDetailsBy: Yup.string()
    //     .required("Packaging Details is required")
    packagingDetails: Yup.object().shape({
      packagingDetailsBy: Yup.string().required(
        "Packaging Details is required"
      ),
      packagingType: Yup.object()
        .shape({
          totalunits: Yup.number(),
          totalweight: Yup.number(),
          totalvolume: Yup.number(),
        })
        .test(
          "check-packaging",
          "Total units, weight, and volume must be greater than 0",
          function (value) {
            const { totalunits, totalweight, totalvolume } = value || {};
            if (
              !totalunits ||
              totalunits <= 0 ||
              !totalweight ||
              totalweight <= 0 ||
              !totalvolume ||
              totalvolume <= 0
            ) {
              return this.createError({
                path: "packagingDetails.packagingType.totalunits",
                message:
                  "Total units, weight, and volume must be greater than 0",
              });
            }
            return true;
          }
        ),
    }),

    paymentTerms: Yup.object().shape({
      incoTerms: Yup.string().required("Payment Terms is required"),
      // optionalVas:Yup.array().min(1, "At least one service must be selected").required("Services selection is required"),
    }),
  });
  const open = Boolean(anchorEl);
  function findflights(values) {
    // console.log(
    //   values.searchquery.destinationAirport,
    //   values,
    //   values.searchquery.originAirport,
    //   "flightratevalues"
    // );
    // navigate("/search-rates/search-rates-result");

    values.searchquery = {
      ...values.searchquery,
      originAirport: {
        ...values.searchquery?.originAirport,
        originVehicleType:
          selectedVehicle?.originVehicle === ""
            ? originvehicle[0]?._id
            : selectedVehicle?.originVehicle,
        pickupToOriginAirportDistance: originDistance
          ? Number.parseFloat(originDistance)
          : 0,
      },
      destinationAirport: {
        ...values.searchquery?.destinationAirport,
        destionationVehicleType:
          selectedVehicle?.destinationVehicle === ""
            ? destinationvehicle[0]?._id
            : selectedVehicle?.destinationVehicle,
        pickupToDestionationAirportDistance: destinationDistance
          ? Number.parseFloat(destinationDistance)
          : 0,
      },
    };

    const bookingeditpayload = {
      airlinepayloadData: editpayload?.airlinepayloadData,
      cargoType: editpayload?.cargoType,
      destinationAirport: editpayload?.destinationAirport,
      goodsDetails: editpayload?.goodsDetails,
      originAirport: editpayload?.originAirport,
      packagingDetails: editpayload?.packagingDetails,
      paymentTerms: editpayload?.PaymentTerms,
    };
    // console.log(values,bookingeditpayload, "updated values");
    const payload = editpayload ? bookingeditpayload : values;
    // console.log(payload,"payload");

    dispatch(searchrates(values))
      .then((res) => {
        // console.log(res, "res");
        // dispatch(setAirportData(res?.payload?.data))

        // navigate("/search-rates/search-rates-result");

        if (
          res?.payload?.success === "error" ||
          res?.payload?.statusCode === 500
        ) {
          console.error("Error response:", res.payload, error);
          // Set the error in the state
          setError(res?.payload?.success || "");
          // Redirect to the error page
        } else {
          // Proceed normally if no error
          navigate("/search-rates/search-rates-result");
        }
      })
      .catch((err) => {});
    // })
  }
  // console.log(finaldata,"finaldata")
  function openmodal(values, msg, type) {
    Modal.confirm({
      title: msg,
      okText: "Proceed",
      cancelButtonProps: {
        style: {
          color: "#FCB614",
          borderColor: "#FCB614",
        },
      },
      onOk() {
        if (type === "origin") {
          values.originAirport.originPickup = false;
          values.originAirport.originLocation = "";
          values.originAirport.originLocationMarker = {};
          values.originAirport.originPortMarker = {};
          values.originAirport.originLocationCountry = "";
        } else if (type === "destination") {
          values.destinationAirport.destinationPickup = false;
          values.destinationAirport.destinationLocation = "";
          values.destinationAirport.destinationLocationMarker = {};
          values.destinationAirport.destinationPortMarker = {};
          values.destinationAirport.destinationLocationCountry = "";
        } else if (type === "thirdcountry") {
          values.originAirport.originPickup = false;
          values.originAirport.originLocation = "";
          values.destinationAirport.destinationPickup = false;
          values.destinationAirport.destinationLocation = "";
        }
        findflights(values);
      },
      onCancel() {},
      okButtonProps: {
        style: {
          color: "#ffffff",
          backgroundColor: "#FCB614",
        },
      },
    });
  }
  const onSubmit = (values, setprops) => {
    if (type === "kam_admin") return;
    // console.log(
    //   values,
    //   values?.destinationAirport.destinationcountryName,
    //   "totalweightvalues",
    //   formikData
    // );

    // console.log(
    //   "data",
    //   destinationairport,
    //   destinationlocation,
    //   originairport,
    //   originlocation
    // );
    // console.log(values, "onsubmit of flight rate");
    // console.log(values.destinationAirport.destinationPickup
    //   ,values.originAirport.originPickup        ,"flightratevalues");
    console.log(values, "origincountrynamevalues");
    const { shipmentTotal, packagingType } = values?.packagingDetails;
    const payloadParams = {
      searchquery: {
        cargoType: values.cargoType,
        ...values,
      },
      productDetails: {
        commodityCode: "9999",
        dgShipment: false,
        natureOfGoods: "MISCELLANEOUS",
        productCode: "GCR",
        specialHandlingCodes: ["GCR"],
      },
      ratePreference: {
        currencyCode: "INR",
      },
      routingPreference: {
        fetchAvailForNextXDays: 4,
        scheduledDepartureDate: moment(
          values?.goodsDetails?.cargoreadydate,
          "DD/MM/YYYY"
        ).format("DD-MMM-YYYY"),
      },

      origin: values?.originAirport?.originAirport.match(/\((.*?)\)/)[1],
      destination:
        values?.destinationAirport?.destinationAirport.match(/\((.*?)\)/)[1],
      origincityName: values?.originAirport.origincityName,
      origincountryName: values?.originAirport?.origincountryName,
      destinationcityName: values?.destinationAirport?.destinationcityName,
      destinationcountryName:
        values?.destinationAirport?.destinationcountryName,
      commodityDetails: "MISCELLANEOUS",
      productCode: "GCR",
      specialHandlingCodes: ["GCR"],
      calculatedType: 1,
      // getQPlusMode: 0,
      shipmentDimensions: packagingType?.packages?.map((item) => {
        const {
          length,
          width,
          height,
          units,
          weight,
          totalsubweight,
          totalsubvolume,
          handling,
        } = item;
        return {
          numberOfPieces: +units,
          length: +length,
          width: +width,
          height: +height,
          dimensionsUnit: "C",
          weightPerPiece: +weight,
          weightUnit: "KG",
          turnable: false,
          volumeWeight: +totalsubvolume,
          chargableWeight: +totalsubweight,
          stackable: checkStackableandTurnable(handling).stackable,
          turnable: checkStackableandTurnable(handling).turnable,
        };
      }),
      shipmentQuantityDetails: {
        chargeableWeight: +shipmentTotal?.totalweight,
        chargeableWeightUnit: "KG",
        totalPieces: +shipmentTotal?.totalunits,
        totalVolume: +shipmentTotal?.totalvolume,
        totalWeight: +shipmentTotal?.totalweight,
        volumeUnit: "CBM",
        weightUnit: "KG",
        total_vol_wt: +shipmentTotal?.totalvolume,
      },
      // requestType:searchFormData?.requestType==="1"?"2": "1",
      requestType:
        editQueryData != null
          ? "1"
          : editdata?.airlinepayloadData?.requestType
          ? "2"
          : "1",
      apiCall: "WEB",
    };
    if (searchFormData?.queryId) {
      payloadParams.queryId = searchFormData?.queryId;
    }
    if (searchFormData?.bookingId) {
      // console.log(searchFormData?.bookingId, "hgh");
      payloadParams.bookingId = searchFormData?.bookingId;
    }
    if (queryId) {
      payloadParams.bookingId = editbookeditem?.bookeditem?.bookingId;
      payloadParams.queryId = queryId;
    }
    if (editbookeditem?.bookingType) {
      payloadParams.bookingType = editbookeditem?.bookingType;
      payloadParams.flightitinaries =
        editbookeditem?.bookeditem?.flightItineraries;
      payloadParams.booking_status = editbookeditem?.booking_status;
    }

    // console.log(editbookeditem?.bookeditem?.bookingId,queryId,"editdataserchformdata");
    // console.log(payloadParams, "payloadParams");
    if (
      values?.destinationAirport?.destinationPickup === true &&
      values?.originAirport?.originPickup === false &&
      values?.packagingDetails?.packagingType?.totalunits !== "" &&
      values?.packagingDetails?.packagingType?.totalvolume !== "" &&
      values?.packagingDetails?.packagingType?.totalweight !== ""
    ) {
      setIsOpen(true);
      setPopup("destination");
      setDestination(values.destinationAirport.destinationLocation);
      setSearchQuery(payloadParams);
      const destinationPayload = {
        origin: values?.destinationAirport?.destinationPortMarker || {
          lat: 0,
          lng: 0,
        },
        destination: values?.destinationAirport?.destinationLocationMarker || {
          lat: 0,
          lng: 0,
        },
      };
      // setDistancePayload(destinationPayload);

      dispatch(caldistance(destinationPayload))
        .then((res) => {
          // console.log(res, "res distance for destination");
          setDestinationDistance(res?.payload?.data?.distance);
          // dispatch(updatenotificationdata(res?.payload));
          const payloadvehicle = {
            cbm: values.packagingDetails.shipmentTotal.totalvolume,
            weight: values.packagingDetails.shipmentTotal.totalweight,
            distance: parseFloat(res?.payload?.data?.distance), //in km
          };
          dispatch(vehicletype(payloadvehicle))
            .then((res) => {
              // console.log(res, "res vehicletype");
              // setVehicle(res?.payload?.data);
              setDestinationVehicle(res?.payload?.data);
              if (
                values.originAirport.originPickup === true &&
                values.destinationAirport.destinationPickup === true
              ) {
                setSelectedVehicle({
                  destinationVehicle: res?.payload?.data?.[0]?._id,
                  originVehicle: res?.payload?.data?.[0]?._id,
                });
              } else if (values.originAirport.originPickup === true) {
                setSelectedVehicle({
                  destinationVehicle: "",
                  originVehicle: res?.payload?.data?.[0]?._id,
                });
              } else if (values.originAirport.destinationPickup === true) {
                setSelectedVehicle({
                  destinationVehicle: res?.payload?.data?.[0]?._id,
                  originVehicle: "",
                });
              }
              // dispatch(updatenotificationdata(res?.payload));
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (
      values.originAirport.originPickup === true &&
      values.destinationAirport.destinationPickup === false &&
      values?.packagingDetails?.packagingType?.totalunits !== "" &&
      values?.packagingDetails?.packagingType?.totalvolume !== "" &&
      values?.packagingDetails?.packagingType?.totalweight !== ""
    ) {
      setIsOpen(true);
      setPopup("origin");
      setOrigin(values.originAirport.originLocation);
      setSearchQuery(payloadParams);
      const originPayload = {
        origin: values?.originAirport?.originLocationMarker || {
          lat: 0,
          lng: 0,
        },
        destination: values?.originAirport?.originPortMarker || {
          lat: 0,
          lng: 0,
        },
      };
      // setDistancePayload(originPayload);
      dispatch(caldistance(originPayload))
        .then((res) => {
          // console.log(res, "res distance for origin");
          setOriginDistance(res?.payload?.data?.distance);
          // dispatch(updatenotificationdata(res?.payload));
          const payloadvehicle = {
            cbm: values.packagingDetails.shipmentTotal.totalvolume,
            weight: values.packagingDetails.shipmentTotal.totalweight,
            distance: parseFloat(res?.payload?.data?.distance), //in km
          };
          dispatch(vehicletype(payloadvehicle))
            .then((res) => {
              // console.log(res, "res vehicletype");
              // setVehicle(res?.payload?.data);
              setOriginVehicle(res?.payload?.data);
              // dispatch(updatenotificationdata(res?.payload));
              if (
                values.originAirport.originPickup === true &&
                values.destinationAirport.destinationPickup === true
              ) {
                setSelectedVehicle({
                  destinationVehicle: res?.payload?.data?.[0]?._id,
                  originVehicle: res?.payload?.data?.[0]?._id,
                });
              } else if (values.originAirport.originPickup === true) {
                setSelectedVehicle({
                  destinationVehicle: "",
                  originVehicle: res?.payload?.data?.[0]?._id,
                });
              } else if (values.originAirport.destinationPickup === true) {
                setSelectedVehicle({
                  destinationVehicle: res?.payload?.data?.[0]?._id,
                  originVehicle: "",
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (
      values.originAirport.originPickup === true &&
      values.destinationAirport.destinationPickup === true &&
      values?.packagingDetails?.packagingType?.totalunits !== "" &&
      values?.packagingDetails?.packagingType?.totalvolume !== "" &&
      values?.packagingDetails?.packagingType?.totalweight !== ""
    ) {
      setIsOpen(true);
      setPopup("both");
      setOrigin(values.originAirport.originLocation);
      setDestination(values.destinationAirport.destinationLocation);
      setSearchQuery(payloadParams);
      const originPayload = {
        origin: values?.originAirport?.originLocationMarker || {
          lat: 0,
          lng: 0,
        },
        destination: values?.originAirport?.originPortMarker || {
          lat: 0,
          lng: 0,
        },
      };

      const destinationPayload = {
        origin: values?.destinationAirport?.destinationPortMarker || {
          lat: 0,
          lng: 0,
        },
        destination: values?.destinationAirport?.destinationLocationMarker || {
          lat: 0,
          lng: 0,
        },
      };

      // Call API for origin
      dispatch(caldistance(originPayload))
        .then((res) => {
          // console.log(res, "res distance for origin");
          setOriginDistance(res?.payload?.data?.distance);
          // dispatch(updatenotificationdata(res?.payload));
          const payloadvehicle = {
            cbm: values.packagingDetails.shipmentTotal.totalvolume,
            weight: values.packagingDetails.shipmentTotal.totalweight,
            distance: parseFloat(res?.payload?.data?.distance), //in km
          };
          dispatch(vehicletype(payloadvehicle))
            .then((res) => {
              // console.log(res, "res vehicletype");
              // setVehicle(res?.payload?.data);
              setOriginVehicle(res?.payload?.data);
              if (
                values.originAirport.originPickup === true &&
                values.destinationAirport.destinationPickup === true
              ) {
                setSelectedVehicle({
                  destinationVehicle: res?.payload?.data?.[0]?._id,
                  originVehicle: res?.payload?.data?.[0]?._id,
                });
              } else if (values.originAirport.originPickup === true) {
                setSelectedVehicle({
                  destinationVehicle: "",
                  originVehicle: res?.payload?.data?.[0]?._id,
                });
              } else if (values.originAirport.destinationPickup === true) {
                setSelectedVehicle({
                  destinationVehicle: res?.payload?.data?.[0]?._id,
                  originVehicle: "",
                });
              }
              // dispatch(updatenotificationdata(res?.payload));
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });

      // Call API for destination
      dispatch(caldistance(destinationPayload))
        .then((res) => {
          // console.log(res, "res distance for destination");
          setDestinationDistance(res?.payload?.data?.distance);
          // dispatch(updatenotificationdata(res?.payload));
          const payloadvehicle2 = {
            cbm: values.packagingDetails.shipmentTotal.totalvolume,
            weight: values.packagingDetails.shipmentTotal.totalweight,
            distance: parseFloat(res?.payload?.data?.distance), //in km
          };
          dispatch(vehicletype(payloadvehicle2))
            .then((res) => {
              // console.log(res, "res vehicletype");
              // setVehicle(res?.payload?.data);
              setDestinationVehicle(res?.payload?.data);
              if (
                values.originAirport.originPickup === true &&
                values.destinationAirport.destinationPickup === true
              ) {
                setSelectedVehicle({
                  destinationVehicle: res?.payload?.data?.[0]?._id,
                  originVehicle: res?.payload?.data?.[0]?._id,
                });
              } else if (values.originAirport.originPickup === true) {
                setSelectedVehicle({
                  destinationVehicle: "",
                  originVehicle: res?.payload?.data?.[0]?._id,
                });
              } else if (values.originAirport.destinationPickup === true) {
                setSelectedVehicle({
                  destinationVehicle: res?.payload?.data?.[0]?._id,
                  originVehicle: "",
                });
              }

              // dispatch(updatenotificationdata(res?.payload));
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      findflights(payloadParams);
    }
  };

  const handleDistanceAndVehicle = (airport, values, type) => {
    const payload = {
      origin: airport?.originLocationMarker || { lat: 0, lng: 0 },
      destination: airport?.originPortMarker || { lat: 0, lng: 0 },
    };

    dispatch(caldistance(payload))
      .then((res) => {
        // console.log(res, `res distance for ${type}`);

        if (type === "origin") setOriginDistance(res?.payload?.data?.distance);
        else setDestinationDistance(res?.payload?.data?.distance);

        // dispatch(updatenotificationdata(res?.payload));

        const vehiclePayload = {
          cbm: values.packagingDetails.shipmentTotal.totalvolume,
          weight: values.packagingDetails.shipmentTotal.totalweight,
          distance: parseFloat(res?.payload?.data?.distance),
        };

        return dispatch(vehicletype(vehiclePayload));
      })
      .then((vehicleRes) => {
        // console.log(vehicleRes, `res vehicletype for ${type}`);
        // if (type === "origin") setOriginVehicle(vehicleRes?.payload?.data);
        // else setDestinationVehicle(vehicleRes?.payload?.data);
        // dispatch(updatenotificationdata(vehicleRes?.payload));
      })
      .catch((error) => {
        console.error(`Error fetching ${type} distance and vehicle:`, error);
      });
  };

  useEffect(() => {
    if (allAirportsState?.allairports?.length > 0) {
      let optionData = [];
      allAirportsState?.allairports.map((item) => {
        // console.log(item,"origincountryname")
        return optionData.push({
          value: `${item.cityName} - (${item.code})`,
          label: `${item.cityName} - (${item.code})`,
          origincityName: item?.cityName,
          origincountryName: item?.countryName,
          country_logo_url: item?.country_logo_url,
        });
      });
      setAirports(optionData);
    } else {
      dispatch(getallairports());
    }
  }, [dispatch, allAirportsState]);
  useEffect(() => {
    // setSelectedVehicle({ destinationVehicle: destinationvehicle[0]?._id, originVehicle: originvehicle[0]?._id });
    function handleResize() {
      if (window.innerWidth < 1024) {
        setWebOpen(false);
      } else {
        setWebOpen(true);
      }
    }
    window.addEventListener("resize", handleResize);
    window.addEventListener("load", handleResize);
    handleResize();
  }, []);

  const handleproceed = () => {
    // console.log(selectedVehicle, initialValues, "selectedValue");

    // console.log(searchquery, "searchquery");

    findflights(searchquery);
    setIsOpen(false);
  };
  // console.log(vehicle);
  // console.log(origin, destination, "origin & destination");
  console.log("searchFormData", searchFormData);

  
  return error === "error" ? (
    <FailureSearchRate />
  ) : (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
      >
        {(formik) => {
          return (
            <Form autoComplete="off">
              <div className="p-5  grid grid-cols-12 gap-4">
                <div className="sm:col-span-12 md:col-span-6 lg:col-span-6 col-span-3">
                  <p className="font-semibold text-xs text-formlabel leading-4 my-2">
                    Origin Airport<span className="text-color-800">*</span>
                  </p>
                  <div
                    onClick={(e) => handleClick(e, formik, "OriginAirport")}
                    // className="relative cursor-pointer bg-white border border-gray-300 text-placeholder text-sm rounded-md font-normal w-fit px-4 py-3 flex items-center justify-between gap-3"
                    className="relative cursor-pointer bg-white border border-gray-300 text-placeholder text-sm rounded-md font-normal w-full px-3 py-3 flex items-center justify-between gap-0"
                  >
                    {formik.values.originAirport.originAirport ? (
                      <span className="text-formlabel">
                        {formik.values.originAirport.originAirport}
                      </span>
                    ) : (
                      <span>Select Origin / Search by Port name or code</span>
                    )}
                    <RightOutlined />
                  </div>
                  <ErrorMessage
                    name="originAirport.originAirport"
                    component={TextError}
                  />
                  <ErrorMessage
                    name="originAirport.originLocation"
                    component={TextError}
                  />
                </div>

                <div className="sm:col-span-12 md:col-span-6 lg:col-span-6 col-span-3">
                  <p className="font-semibold text-xs text-formlabel leading-4 my-2">
                    Destination Airport<span className="text-red-800">*</span>
                  </p>
                  <div
                    onClick={(e) =>
                      handleClick(e, formik, "DestinationAirport")
                    }
                    className="relative cursor-pointer bg-white border border-gray-300 text-placeholder text-sm rounded-md font-normal w-full px-3 py-3 flex items-center justify-between gap-0"
                  >
                    {formik.values.destinationAirport.destinationAirport ? (
                      <span className="text-formlabel">
                        {formik.values.destinationAirport.destinationAirport}
                      </span>
                    ) : (
                      <span>
                        Select Destination / Search by Port name or code
                      </span>
                    )}
                    <RightOutlined />
                  </div>
                  <ErrorMessage
                    name="destinationAirport.destinationAirport"
                    component={TextError}
                  />
                  <ErrorMessage
                    name="destinationAirport.destinationLocation"
                    component={TextError}
                  />
                </div>
                <div className="sm:col-span-12 md:col-span-12 lg:col-span-12 col-span-6">
                  <p className="font-semibold text-xs text-formlabel leading-4 my-2">
                    Goods Details
                  </p>
                  <div
                    onClick={(e) => handleClick(e, formik, "GoodDetails")}
                    className="relative cursor-pointer bg-white border border-gray-300 text-placeholder text-sm rounded-md font-normal w-full px-5 py-3 flex items-center justify-between gap-3"
                  >
                    {formik.values.goodsDetails ? (
                      <div className="text-white font-normal text-sm leading-4 flex items-center flex-wrap gap-1">
                        <span className="bg-primary px-2.5 py-1 rounded-sm ">
                          {formik.values.goodsDetails.cargoreadydate}
                        </span>
                        <span className="bg-primary px-2.5 py-1 rounded-sm ">
                            {
    comodityMaster?.find(
      (option) =>
        parseInt(option.value) === parseInt(formik?.values?.commodityId?formik?.values?.commodityId:editdata?.commodityId?editdata?.commodityId:98)
    )?.label
  }
                        </span>
                        {/* {formik.values.goodsDetails.commonditytype
                          .commonditytype === "General Cargo" ? (
                          // <span className="bg-primary px-2.5 py-1 rounded-sm ">
                          //   {
                          //     formik.values.goodsDetails.commonditytype
                          //       .generalcargo.generalgoods
                          //   }
                          // </span>
                          <span></span>
                        ) : (
                          <span className="bg-primary px-2.5 py-1 rounded-sm ">
                            {
                              formik.values.goodsDetails.commonditytype
                                .commonditytypesub
                            }
                          </span>
                        )} */}
                      </div>
                    ) : (
                      <span>Add Goods Details</span>
                    )}
                    <RightOutlined />
                  </div>
                  <ErrorMessage
                    name="goodsDetails.commonditytype.commonditytype"
                    component={TextError}
                  />
                </div>
                <div className="sm:col-span-12 md:col-span-12 lg:col-span-12 col-span-5">
                  <p className="font-semibold text-xs text-formlabel leading-4 my-2">
                    Packaging Details
                  </p>
                  <div
                    onClick={(e) => handleClick(e, formik, "PackagingDetails")}
                    className="relative cursor-pointer bg-white border border-gray-300 text-placeholder text-sm rounded-md font-normal w-full px-5 py-3 flex items-center justify-between gap-3"
                  >
                    {formik.values.packagingDetails.packagingDetailsBy ? (
                      formik.values.packagingDetails.packagingDetailsBy ===
                      "Packaging Type" ? (
                        <div className="text-white font-normal text-sm leading-4 flex items-center flex-wrap gap-1">
                          <span className="bg-primary px-2.5 py-1 rounded-sm ">
                            Quantity:{" "}
                            {formik.values.packagingDetails?.packagingType
                              ?.totalunits
                              ? formik.values.packagingDetails?.packagingType
                                  ?.totalunits
                              : 0}{" "}
                          </span>
                          <span className="bg-primary px-2.5 py-1 rounded-sm ">
                            Total Weight:{" "}
                            {formik.values.packagingDetails?.packagingType
                              ?.totalweight
                              ? formik.values.packagingDetails?.packagingType
                                  ?.totalweight
                              : 0}{" "}
                            {
                              formik.values.packagingDetails.shipmentTotal
                                .weightunit
                            }
                          </span>
                          <span className="bg-primary px-2.5 py-1 rounded-sm ">
                            Total Volume:{" "}
                            {formik.values.packagingDetails?.packagingType
                              ?.totalvolume
                              ? formik.values.packagingDetails?.packagingType
                                  ?.totalvolume
                              : 0}{" "}
                            {formik.values.packagingDetails.shipmentTotal.unit}
                          </span>
                        </div>
                      ) : (
                        <div className="text-white font-normal text-sm leading-4 flex items-center flex-wrap gap-1">
                          <span className="bg-primary px-2.5 py-1 rounded-sm ">
                            Total Unit:{" "}
                            {
                              formik.values.packagingDetails.shipmentTotal
                                .totalunits
                            }
                          </span>
                          <span className="bg-primary px-2.5 py-1 rounded-sm ">
                            Total Weight:{" "}
                            {
                              formik.values.packagingDetails.shipmentTotal
                                .totalweight
                            }
                          </span>
                          <span className="bg-primary px-2.5 py-1 rounded-sm ">
                            Total Volume:{" "}
                            {
                              formik.values.packagingDetails.shipmentTotal
                                .totalvolume
                            }
                          </span>
                        </div>
                      )
                    ) : (
                      <span>Add Packaging Details</span>
                    )}
                    <RightOutlined />
                  </div>
                  <ErrorMessage
                    name="packagingDetails.packagingType.totalunits" //packingDetails.packagingDetailsBy
                    component={TextError}
                  />
                </div>
                <div className="sm:col-span-12 md:col-span-12 lg:col-span-12 col-span-5">
                  <p className="font-semibold text-xs text-formlabel leading-4 my-2">
                    Payment Terms<span className="text-red-800">*</span>
                  </p>
                  <div
                    onClick={(e) => handleClick(e, formik, "PaymentTerms")}
                    className="relative cursor-pointer bg-white border border-gray-300 text-placeholder text-sm rounded-md font-normal w-full px-5 py-3 flex items-center justify-between gap-3"
                  >
                    {formik.values.paymentTerms.incoTerms ||
                    formik.values.paymentTerms.paymentType ? (
                      <div className="text-white font-normal text-sm leading-4 flex items-center flex-wrap gap-3">
                        <span className="bg-primary px-2.5 py-1 rounded-sm ">
                          {formik.values.paymentTerms.paymentType}
                        </span>
                        {formik.values.paymentTerms.incoTerms && (
                          <span className="bg-primary px-2.5 py-1 rounded-sm ">
                            {formik.values.paymentTerms.incoTerms}
                          </span>
                        )}
                        {formik.values.paymentTerms.optionalVas.length > 0 && (
                          <span>
                            {/* {formik.values.paymentTerms.optionalVas.map(
                              (item, index) => (
                                <span key={index} className="bg-primary px-2.5 py-1 rounded-sm mr-2">
                                  {item}{" "}

                                </span>
                              )
                            )} */}
                            {/* {formik?.values?.paymentTerms?.optionalVas?.map((id, index) => {
                              console.log(vasoptiondata, formik?.values?.paymentTerms,"vasoptiondata");
  const matchedItem = vasoptiondata?.find(v => v?.vatId === id);
  return matchedItem ? (
    <span key={index} className="bg-primary px-2.5 py-1 rounded-sm mr-2">
      {matchedItem.type}-{matchedItem.chargeHeadName}
    </span>
  ) : null;
})} */}

                            {Array.isArray(
                              formik?.values?.paymentTerms?.optionalVas
                            ) && (
                              <div className="flex flex-col">
                                {formik.values.paymentTerms.optionalVas.map(
                                  (item, index) => {
                                    // If item is already an object (has 'type' and 'chargeHead'), render directly
                                    if (typeof item === "object") {
                                      return (
                                        <span
                                          key={index}
                                          className="bg-primary px-2.5 py-1  m-2 rounded-sm mr-2"
                                        >
                                          {item.type.charAt(0).toUpperCase() +
                                            item.type.slice(1)}{" "}
                                          - {item.chargeHeadName}
                                        </span>
                                      );
                                    }

                                    // Else item is ID, find matching item in vasoptiondata
                                    const matchedItem = vasoptiondata?.find(
                                      (v) => v?.vatId === item
                                    );
                                    return matchedItem ? (
                                      <span
                                        key={index}
                                        className="bg-primary px-2.5 py-1 m-2 rounded-sm mr-2"
                                      >
                                        {matchedItem.type
                                          .charAt(0)
                                          .toUpperCase() +
                                          matchedItem.type.slice(1)}
                                        -{matchedItem.chargeHeadName}
                                      </span>
                                    ) : null;
                                  }
                                )}
                              </div>
                            )}
                          </span>
                        )}
                      </div>
                    ) : (
                      <span>Add Payment Terms</span>
                    )}
                    <RightOutlined />
                  </div>
                  <ErrorMessage
                    name="paymentTerms.incoTerms"
                    component={TextError}
                  />
                </div>
                <div className="sm:col-span-12 md:col-span-6 lg:col-span-6 col-span-2 relative flex items-end w-full">
                  {type !== "kam_admin" && (
                    <button
                      type="submit"
                      className="text-white bg-primary hover:bg-secondary font-medium rounded-lg text-sm px-4 py-3 text-center  w-full flex items-center justify-center gap-2 shadow-searchbox"
                    >
                      <SearchOutlined />
                      <span>Search</span>
                    </button>
                  )}
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
      {isOpen && popup === "destination" && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-120">
            <div className="flex justify-start pt-2 pl-2 bg-gray-100 text-[#f5aa06] text-2xl rounded-md text-center items-center border-b pb-2">
              {/* <h2 className="text-lg font-semibold"> */}
              Confirm delivery and Vehicle Type
              {/* </h2> */}
            </div>
            <p className="text-gray-500 mt-4">
              Since you have requested door pickup and delivery, please confirm
              <br />
              the vehicle type that suits your requirement.
            </p>
            <div className="space-y-4 flex flex-col justify-between items-center w-fit py-4">
              <div className="space-y-4 flex justify-between items-center py-4">
                <div className="p-2 m-5">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Destination Location{" "}
                    <span className="block">(_ of Goods)</span>
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                    // placeholder="Enter contact person name"
                    defaultValue={destination}
                    disabled={true}
                  />
                </div>
                <div className="p-2 m-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Distance
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                    // placeholder="Enter contact number"
                    disabled={true}
                    defaultValue={destinationDistance}
                  />
                </div>
                <div className="p-2 m-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Vehicle Type
                  </label>

                  <select
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                    value={selectedVehicle?.destinationVehicle}
                    onChange={(e) =>
                      setSelectedVehicle((prev) => ({
                        ...prev,
                        destinationVehicle: e.target.value,
                      }))
                    }
                  >
                    <option value="">
                      {destinationvehicle[0]?.name
                        ? destinationvehicle[0]?.name
                        : "Vehicle Type"}
                    </option>
                    {destinationvehicle?.map((item) => (
                      <option key={item._id} value={item._id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="flex justify-end space-x-2 pr-12">
              <button
                type="button"
                onClick={handlemodalclose}
                className="px-4 py-2 border rounded bg-black text-white hover:bg-yellow-600"
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 border rounded bg-yellow-600 text-white hover:bg-black"
                onClick={handleproceed}
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      )}
      {isOpen && popup === "origin" && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-120">
            <div className="flex justify-start pt-2 pl-2 bg-gray-100 text-[#f5aa06] text-2xl rounded-md text-center items-center border-b pb-2">
              {/* <h2 className="text-lg font-semibold"> */}
              Confirm delivery and Vehicle Type
              {/* </h2> */}
            </div>
            <p className="text-gray-500 mt-4">
              Since you have requested door pickup and delivery, please confirm
              <br />
              the vehicle type that suits your requirement.
            </p>
            <div className="space-y-4 flex flex-col justify-between items-center w-fit py-4">
              <div className="space-y-4 flex justify-between items-center py-4">
                <div className="p-2 m-5">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Origin Location <span className="block">(_ of Goods)</span>
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                    // placeholder="Enter contact person name"
                    defaultValue={origin}
                    disabled={true}
                  />
                </div>
                <div className="p-2 m-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Distance
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                    // placeholder="Enter contact number"
                    defaultValue={originDistance}
                    disabled={true}
                  />
                </div>
                <div className="p-2 m-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Vehicle Type
                  </label>

                  <select
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                    value={selectedVehicle?.originVehicle}
                    onChange={(e) =>
                      setSelectedVehicle((prev) => ({
                        ...prev,
                        originVehicle: e.target.value,
                      }))
                    }
                  >
                    <option value={originvehicle[0]?._id}>
                      {originvehicle[0]?.name
                        ? originvehicle[0]?.name
                        : "Vehicle Type"}
                    </option>
                    {originvehicle?.map((item) => (
                      <option key={item._id} value={item._id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="flex justify-end space-x-2 pr-12">
              <button
                type="button"
                onClick={handlemodalclose}
                className="px-4 py-2 border rounded bg-black text-white hover:bg-yellow-600"
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 border rounded bg-yellow-600 text-white hover:bg-black"
                onClick={handleproceed}
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      )}
      {isOpen && popup === "both" && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-120">
            <div className="flex justify-start pt-2 pl-2 bg-gray-100 text-[#f5aa06] text-2xl rounded-md text-center items-center border-b pb-2">
              {/* <h2 className="text-lg font-semibold"> */}
              Confirm delivery and Vehicle Type
              {/* </h2> */}
              {/* <button onClick={onClose} className="text-gray-500 hover:text-gray-700">&times;</button> */}
            </div>
            <p className="text-gray-500 mt-4">
              Since you have requested door pickup and delivery, please confirm
              <br />
              the vehicle type that suits your requirement.
            </p>
            <div className="space-y-4 flex flex-col justify-between items-center w-fit py-4">
              <div className="space-y-4 flex justify-between items-center ">
                <div className="p-2 m-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Destination Location{" "}
                    <span className="block">(_ of Goods)</span>
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                    // placeholder="Enter contact person name"
                    defaultValue={destination}
                    disabled={true}
                  />
                </div>
                <div className="p-2 m-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Distance
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                    // placeholder="Enter contact number"
                    disabled={true}
                    defaultValue={destinationDistance}
                  />
                </div>
                <div className="p-2 m-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Vehicle Type
                  </label>

                  <select
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                    value={selectedVehicle?.destinationVehicle}
                    onChange={(e) =>
                      setSelectedVehicle((prev) => ({
                        ...prev,
                        destinationVehicle: e.target.value,
                      }))
                    }
                  >
                    <option value={destinationvehicle[0]?._id}>
                      {destinationvehicle[0]?.name
                        ? destinationvehicle[0]?.name
                        : "Vehicle Type"}
                    </option>
                    {destinationvehicle?.map((item) => (
                      <option key={item._id} value={item._id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="space-y-4 flex justify-between items-center ">
                <div className="p-2 m-2 ">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    origin Location <span className="block">(_ of Goods)</span>
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                    // placeholder="Enter contact person name"
                    defaultValue={origin}
                    disabled={true}
                  />
                </div>
                <div className="p-2 m-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Distance
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                    // placeholder="Enter contact number"
                    disabled={true}
                    defaultValue={originDistance}
                  />
                </div>
                <div className="p-2 m-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Vehicle Type
                  </label>

                  <select
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                    value={selectedVehicle?.originVehicle}
                    onChange={(e) =>
                      setSelectedVehicle((prev) => ({
                        ...prev,
                        originVehicle: e.target.value,
                      }))
                    }
                  >
                    <option value={originvehicle[0]?._id}>
                      {originvehicle[0]?.name
                        ? originvehicle[0]?.name
                        : "Vehicle Type"}
                    </option>
                    {originvehicle?.map((item) => (
                      <option key={item._id} value={item._id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="flex justify-end space-x-2 pr-12">
              <button
                type="button"
                onClick={handlemodalclose}
                className="px-4 py-2 border rounded bg-black text-white hover:bg-yellow-600"
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 border rounded bg-yellow-600 text-white hover:bg-black"
                onClick={handleproceed}
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      )}
      <Popover
        className="w-full overflow-y-scroll"
        PaperProps={{
          // style: {
          //   width:
          //     popForm === "PackagingDetails" && webopen === true
          //       ? "75%"
          //       : webopen === false
          //       ? "100%"
          //       : popForm==="OriginAirport" || popForm==="DestinationAirport" ? "35%" : "50%",
          //   boxShadow: "10px 10px 10px 10px gray",
          //   borderRadius: "16px",

          // },
          style: {
            width:
              popForm === "PackagingDetails" ||
              (popForm === "GoodDetails" && webopen === true)
                ? "75%"
                : "auto", // Fit width to content
            height:
              popForm === "GoodDetails" && webopen === true ? "75%" : "auto", // Fit height to content
            maxWidth: "none", // Allow full dynamic width
            boxShadow: "10px 10px 10px 10px gray",
            borderRadius: "16px",
            marginTop: "5px",
            marginBottom: "5px",
            overflowY: "auto",
          },
        }}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        // anchorOrigin={{ vertical: "top", horizontal: "left" }}
        // transformOrigin={{ vertical: "top", horizontal: "left" }}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        {popForm === "OriginAirport" ? (
          <Suspense fallback={<Skeleton active />}>
            <OriginAirport
              formikData={formikData}
              setAnchorEl={setAnchorEl}
              airports={airports}
              allairports={allAirportsState?.allairports}
            />
          </Suspense>
        ) : popForm === "DestinationAirport" ? (
          <Suspense fallback={<Skeleton active />}>
            <DestinationAirport
              formikData={formikData}
              setAnchorEl={setAnchorEl}
              airports={airports}
              allairports={allAirportsState?.allairports}
            />
          </Suspense>
        ) : popForm === "GoodDetails" ? (
          <Suspense fallback={<Skeleton active />}>
            <GoodDetails
              formikData={formikData}
              setAnchorEl={setAnchorEl}
              anchorEl={anchorEl}
            />
          </Suspense>
        ) : popForm === "PackagingDetails" ? (
          <Suspense fallback={<Skeleton active />}>
            <PackagingDetails
              formikData={formikData}
              setAnchorEl={setAnchorEl}
            />
          </Suspense>
        ) : (
          popForm === "PaymentTerms" && (
            <Suspense fallback={<Skeleton active />}>
              <PaymentTerms
                formikData={formikData}
                setVasOptionData={setVasOptionData}
                setAnchorEl={setAnchorEl}
                allairports={allAirportsState?.allairports}
                // originAirport={formik.values.originAirport}
                // destinationAirport={formik.values.destinationAirport}
              />
            </Suspense>
          )
        )}
      </Popover>
    </>
  );
};

export default FlightRate;
